/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../../../components/footer/Footer";
import Header from "../../../../components/header/Header";
import HeaderMenu from "../../../../components/header/HeaderMenu";
import SphereLoader from "../../../../components/loaders/SphereLoader";
import { getMobileDomainBrandIdentity } from "../../../../store/actions/manager.action";
import { Loading } from "../../../../utils/helpers/constants";
import Body from "./Body";

function MobileAppSettings() {
  const dispatch = useDispatch();

  const [fontStore, setFontStore] = useState([]);

  const { domainBrand, component, manager } = useSelector(
    ({ domainBrandReducer, componentReducer, managerReducer }) => ({
      domainBrand: domainBrandReducer,
      component: componentReducer,
      manager: managerReducer,
    })
  );

  const loadState = domainBrand.loading === Loading.FETCHING;

  const fetchGoogleFonts = async () => {
    try {
      const response = await axios.get(
        "https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBwIX97bVWr3-6AIUvGkcNnmFgirefZ6Sw"
      );
      if (response.status === 200) {
        setFontStore(response?.data?.items);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(async () => {
    await fetchGoogleFonts();
  }, []);

  useEffect(() => {
    if (manager.loadingMobile !== Loading.SUCCESS) {
      dispatch(getMobileDomainBrandIdentity());
    }
  }, []);

  return (
    <div className={`page ${component["mobileNav"] ? "active" : ""}`}>
      {loadState ? (
        <SphereLoader />
      ) : (
        <>
          <div className="page-main">
            <div className="app-sidebar__overlay" data-bs-toggle="sidebar" />
            <Header domainBrand={domainBrand} />
            <HeaderMenu
              menu="settings"
              active="Corridors"
              domainBrand={domainBrand}
            />
            <Body
              domainBrand={domainBrand}
              fontStore={fontStore}
              domainMobile={manager?.domainBrand}
            />
          </div>
        </>
      )}
      <Footer domainBrand={domainBrand} />
    </div>
  );
}

export default MobileAppSettings;
